module.exports = __webpack_public_path__ + "img/组 17 拷贝 2.bb04476d.png";